import './Drawer.css';
export var DrawerBackdropCSS = '_14971977-3-12-1';
export var DrawerCSS = '_14971970-3-12-1';
export var DrawerContentCSS = '_14971978-3-12-1';
export var DrawerPlacementCSS = {left:'_14971971-3-12-1',right:'_14971972-3-12-1'};
export var DrawerWidthStyles = {narrow:'_14971973-3-12-1',medium:'_14971974-3-12-1',wide:'_14971975-3-12-1',full:'_14971976-3-12-1'};